document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-ranking-list').forEach(function (listEl) {
    var collectionHandle = listEl.dataset.collectionHandle;
    if (!collectionHandle) return;

    fetch('/collections/' + collectionHandle + '/products.json?sort_by=best-selling&limit=5')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.products;
        if (!products || products.length === 0) {
          listEl.innerHTML = '';
          return;
        }

        var html = '';
        products.forEach(function (product, index) {
          var title = product.title || '';
          var url = '/products/' + product.handle;
          var imageUrl = '';
          if (product.images && product.images.length > 0) {
            imageUrl = product.images[0].src;
            imageUrl = imageUrl.replace(/(\.[^.]+)$/, '_400x400$1');
          }
          var productType = product.product_type || '';

          var seriesPart = '';
          var innerTitle = title;
          var quoteStart = title.indexOf('「');
          var quoteEnd = title.indexOf('」');
          if (quoteStart !== -1 && quoteEnd !== -1) {
            seriesPart = title.substring(0, quoteStart);
            innerTitle = title.substring(quoteStart, quoteEnd + 1);
          }

          html += '<li class="collection-ranking-item">';
          html += '<div class="ranking-number">' + (index + 1) + '</div>';
          html += '<div class="hex-container">';
          html += '<div class="hex-mask--ranking">';
          html += '<a href="' + url + '">';
          if (imageUrl) {
            html += '<img src="' + imageUrl + '" alt="' + title.replace(/"/g, '&quot;') + '" width="400" height="400" loading="lazy">';
          }
          html += '</a>';
          html += '</div></div>';
          html += '<div class="ranking-text">';
          if (productType) {
            html += '<div class="product-type">' + productType + '</div>';
          }
          if (seriesPart) {
            html += '<div class="series-name">' + seriesPart + '</div>';
            html += '<div class="title-in-quotes">' + innerTitle + '</div>';
          } else {
            html += '<div class="title-in-quotes">' + title + '</div>';
          }
          html += '</div>';
          html += '</li>';
        });

        listEl.innerHTML = html;
      })
      .catch(function (err) {
        console.error('Ranking fetch error:', err);
        listEl.innerHTML = '';
      });
  });
});